import { Input } from '@/components/ui/input';
import { CreditCard, Building2, Globe, DollarSign } from 'lucide-react';

const METHODS = [
  { key: 'card', label: 'Card', Icon: CreditCard },
  { key: 'bank', label: 'Bank', Icon: Building2 },
  { key: 'online', label: 'Online', Icon: Globe },
];

// Expected vs actual for non-cash payments at shift close. Empty actual = Pending Verification (never auto-filled).
export const ShiftNonCashActuals = ({ breakdown = {}, actuals, onChange, fmt }) => {
  const shown = METHODS.filter((m) => (breakdown[m.key] || 0) !== 0);
  return (
    <div className="rounded-xl border p-3 space-y-2" data-testid="shift-noncash-actuals">
      <p className="text-sm font-medium">Card / Bank / Online</p>
      {shown.length === 0 && <p className="text-xs text-muted-foreground">No non-cash payments this shift.</p>}
      {shown.map(({ key, label, Icon }) => {
        const exp = breakdown[key] || 0;
        const raw = actuals[key];
        const has = raw !== undefined && raw !== '' && !Number.isNaN(parseFloat(raw));
        const diff = has ? Math.round((parseFloat(raw) - exp) * 100) / 100 : null;
        return (
          <div key={key} className="grid grid-cols-[1fr_auto_8rem_auto] items-center gap-2 text-sm" data-testid={`noncash-row-${key}`}>
            <span className="flex items-center gap-1.5"><Icon size={14} />{label}</span>
            <span className="text-xs text-muted-foreground" data-testid={`noncash-expected-${key}`}>Exp {fmt(exp)}</span>
            <Input type="number" step="0.01" min="0" value={raw ?? ''} placeholder="Terminal total"
              onChange={(e) => onChange({ ...actuals, [key]: e.target.value })} className="h-9" data-testid={`noncash-actual-${key}`} />
            <span className={`text-xs font-medium min-w-[6rem] text-right ${diff === null ? 'text-warning' : Math.abs(diff) < 0.01 ? 'text-success' : 'text-error'}`}
              data-testid={`noncash-status-${key}`}>
              {diff === null ? 'Pending' : Math.abs(diff) < 0.01 ? 'Matched' : `${diff > 0 ? '+' : ''}${diff.toFixed(2)}`}
            </span>
          </div>
        );
      })}
      {(breakdown.credit || 0) !== 0 && (
        <p className="text-xs text-muted-foreground flex items-center gap-1" data-testid="noncash-credit">
          <DollarSign size={12} /> Customer credit {fmt(breakdown.credit)} (receivable, not counted)
        </p>
      )}
      <p className="text-[11px] text-muted-foreground">Leave blank if not checked — a manager can verify later.</p>
    </div>
  );
};
